module.exports = ".margem-footer{\r\n    margin-bottom: 150px!important;\r\n}\r\n\r\n.espacamento{\r\n    margin-top: 50px;\r\n}\r\n\r\n.banner-img{    \r\n    background-image: url('welcome.52b64d757e8162f7db6b.png') !important;\r\n    background-repeat: no-repeat !important;\r\n    background-size: 100%;\r\n    padding-top: 110px !important;\r\n    height: 220px !important;\r\n    width: auto !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/administracao/versao/edit-versao/edit-versao.component.css
// module id = ./src/app/pages/administracao/versao/edit-versao/edit-versao.component.css
// module chunks = main